import { Close, Female, Folder, Male, Save } from '@mui/icons-material'
import { Avatar, Box, Button, Grid, IconButton, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { formatoNum } from '../../lib/format'

const SociosTab = ({ socios, imagenes, editable, setData, handleUpdate, setImgs }) => {
    const handleInput = (e) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                imagen.paso = 'total_socios';
                setData({
                    target: { name: 'imagenes', value: [...imagenes, imagen] }
                }, 0);
            };
            reader.readAsDataURL(imagen);
        }
    };

    const removeImg = (imgurl, isNew = false) => {
        setData({ target: { name: 'imagenes', value: imagenes.filter(img => (isNew ? img.dataurl : img.url_img) !== imgurl) } });
    }


    if (socios) {
        return (
            <Box sx={{ m: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={4}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Socios
                        </Typography>
                        {editable ?
                            <Stack direction="column" spacing={1}>
                                <TextField onChange={setData} value={socios.numero_hombres} name="numero_hombres" label="Cant. hombres" />
                                <TextField onChange={setData} value={socios.numero_mujeres} name="numero_mujeres" label="Cant. mujeres" />
                            </Stack>
                            :
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Avatar variant="rounded" sx={{ bgcolor: '#6acfff' }}>
                                    <Male />
                                </Avatar>
                                <Typography sx={{ ml: 2, mr: 4 }}>
                                    {formatoNum(socios.numero_hombres)}
                                </Typography>
                                <Avatar variant="rounded" sx={{ bgcolor: '#ffafff' }}>
                                    <Female />
                                </Avatar>
                                <Typography sx={{ ml: 2, mr: 2 }}>
                                    {formatoNum(socios.numero_mujeres)}
                                </Typography>
                            </Box>
                        }
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Empleados
                        </Typography>
                        {editable ?
                            <Stack direction="column" spacing={1}>
                                <TextField onChange={setData} value={socios.empleados_operarios} name="empleados_operarios" label="Cant. operarios" />
                                <TextField onChange={setData} value={socios.empleados_tecnicos} name="empleados_tecnicos" label="Cant. técnicos" />
                                <TextField onChange={setData} value={socios.empleados_administrativos} name="empleados_administrativos" label="Cant. administrativos" />
                            </Stack>
                            :
                            <Grid container spacing={2}>
                                <Grid item lg={4}>
                                    <Typography fontWeight='bold' textAlign='center'>Operarios</Typography>
                                    <Typography textAlign='center'>{formatoNum(socios.empleados_operarios)}</Typography>
                                </Grid>
                                <Grid item lg={4}>
                                    <Typography fontWeight='bold' textAlign='center' >Técnicos</Typography>
                                    <Typography textAlign='center'>{formatoNum(socios.empleados_tecnicos)}</Typography>
                                </Grid>
                                <Grid item lg={4}>
                                    <Typography fontWeight='bold' textAlign='center'>Administrativos</Typography>
                                    <Typography textAlign='center'>{formatoNum(socios.empleados_administrativos)}</Typography>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Box sx={{ my: 2 }}>
                    <Typography sx={{ mb: 2 }} variant="h6">Fotogalería de socios y/o personal de la empresa:</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        {/* {imagenes.total_socios && Object.values(imagenes.total_socios.galeria_socios).map((img) => {
                            return (
                                <img src={img} width="300px" alt="" />
                            )
                        })} */}
                        {!editable &&
                            <Grid container spacing={2}>
                                {Object.values(imagenes)
                                    .filter((i) => i.paso === 'total_socios')
                                    .map((img, index) => {
                                        return (
                                            <Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={4}
                                                key={index}
                                                sx={{ display: 'flex', justifyContent: 'center' }}
                                            >
                                                <img
                                                    src={img.url_img ?? img.dataurl}
                                                    width="100%"
                                                    alt={index}
                                                    style={{ maxWidth: '300px', objectFit: 'contain' }}
                                                />
                                            </Grid>
                                        )
                                    })}
                            </Grid>
                        }
                        {editable &&
                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                                    {Object.values(imagenes).filter((i) => i.paso == 'total_socios').map((image, index) => (
                                        <Grid
                                            item
                                            md={4}
                                            key={index}
                                            sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center', width: '100%' }}>
                                            <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => image.url_img ? removeImg(image.url_img) : removeImg(image.dataurl, true)}>
                                                <Close />
                                            </IconButton>
                                            <img src={image.url_img ?? image.dataurl} alt={image.name} style={{ objectFit: 'contain' }} width="150px" />
                                        </Grid>
                                    ))}
                                    <Grid item xs={12}>
                                        <Button
                                            disabled={Object.values(imagenes).filter((i) => i.paso == 'total_socios').length > 2}
                                            component="label"
                                            variant="contained"
                                            startIcon={<Folder />}
                                        >
                                            Agregar <input name="imagenes" onInputCapture={handleInput} type="file" accept='image/*' hidden />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        }
                    </Box>
                </Box>
                {/* Boton para actualizar datos de este tab. (Excepto imagenes, se actualizaran al vuelo) */}
                {editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                    </Box>
                }

            </Box>
        )
    }
}
export default SociosTab